<template>
    <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
        <div class="modal-body-container">
            <h4 class="text-center mt-4">{{ $t('changeStatus') }}</h4>  
            <!-- Status dropdown -->    
            <div role="group" class="form-group flex-grow-1">
                <label class="m-0"> {{ $t('status') }}</label>
                <SingleOptionDropdown v-model="status" :options="statusOptions" :title="$t('status')" :index="0"></SingleOptionDropdown>
            </div>       
            <!-- Confirm -->
            <div class="d-flex justify-content-center">  
                <CSpinner v-if="postOrderChangeStatusOutput === null" variant="success" small></CSpinner>
                <CButton v-else :disabled="status == null || !orders || !orders.length" type="button" class="mb-4 btn btn-primary align-self-center" @click="confirmRequested">{{ $t('confirm') }}</CButton>
            </div>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';
import { mapState, mapActions } from 'vuex'
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

export default {
    extends: BasePopUp,
    components: {BasePopUp, SingleOptionDropdown},
    methods:{
        ...mapActions('orders', ['postOrderChangeStatus']),
        confirmRequested()
        {       
            var input = {ids: this.orders.map(x=> x.id), status: this.status};
            this.postOrderChangeStatus(input);
        },
        closeConfirmRequested()
        {
            this.$emit("closeConfirmRequested");
        }
    },
    data() {
        return {
            status: null,
            statusOptions: [{label: this.$t("orderStatus.pendingPayment"), key: "PendingPayment"}, {label: this.$t("orderStatus.pendingProcessing"), key: "PendingProcessing"}, {label: this.$t("orderStatus.processing"), key: "Processing"}, {label: this.$t("orderStatus.readyToShip"), key: "ReadyToShip"}, {label: this.$t("orderStatus.shipped"), key: "Shipped"}, {label: this.$t("orderStatus.concluded"), key: "Concluded"}, {label: this.$t("orderStatus.canceled"), key: "Canceled"} ],
        };
    },
    computed:
    {
        ...mapState('orders', ['postOrderChangeStatusOutput']),
    },
    props:{
        orders:
        {
            type: Array
        },
    },
    watch:
    {
        postOrderChangeStatusOutput: function(val)
        {
            if(val)
            {
                this.$emit("closeConfirmRequested", true);
            }
        }
    }
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;    
        min-height: 200px;
    
    }
</style>